import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { KPIComponent } from '../landing-page/KPI/kpi.component';
import { ScheduleComponent } from '../landing-page/schedule/schedule.component';
import { LandingClientService } from 'src/app/common/services/landing-page.client';
import { StorageService } from 'src/app/common/services/storage.service';
import { ViewTypeService } from 'src/app/services/view-type.service';
import { ViewType } from 'src/app/common/enums/view-type.enum';

@Component({
  selector: 'app-tile',
  standalone: true,
  imports: [CommonModule, KPIComponent, ScheduleComponent],
  templateUrl: './tile.component.html',
  styleUrls: ['./tile.component.scss']
})
export class TileComponent implements OnInit, OnDestroy {
  isDOR = false;
  loaded = false;
  refreshing = false;
  lastRefreshed = '';

  private viewTypeSubscription!: Subscription;

  constructor(
    private landingClientService: LandingClientService,
    private storageService: StorageService,
    private viewTypeService: ViewTypeService
  ) {}

  ngOnInit(): void {
    this.landingClientService.getJobTitleDetails().subscribe((userTitleDetails) => {
      const user = JSON.parse(this.storageService.getUser() ?? '{}');
      this.isDOR = (userTitleDetails && userTitleDetails.isDOR) || user.issuperuser === true;
      this.viewTypeService.setSelectedViewType(this.isDOR ? ViewType.DOR_VIEW : ViewType.THERAPIST_VIEW);
      this.lastRefreshed = new Date().toLocaleTimeString();
      this.loaded = true;
    });

    this.viewTypeSubscription = this.viewTypeService.selectedViewType$.subscribe((viewType) => {
      if (viewType === ViewType.DOR_VIEW) this.isDOR = true;
      else if (viewType === ViewType.THERAPIST_VIEW) this.isDOR = false;
    });
  }

  ngOnDestroy(): void {
    this.viewTypeSubscription?.unsubscribe();
  }

  refresh(): void {
    this.refreshing = true;
    setTimeout(() => {
      this.refreshing = false;
      this.lastRefreshed = new Date().toLocaleTimeString();
    });
  }
}
